import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/page/Login.vue'
import Home from '@/page/home.vue'
import MaterialManage from '@/page/material/MaterialManage.vue'
import MaterialAdd from '@/page/material/MaterialAdd.vue'
import MaterialDetail from '@/page/material/MaterialDetail.vue'
import UnitManage from '@/page/unit/unit-manage.vue'
import MaterialTypeManage from '@/page/material-type/material-type-manage.vue'
import ShopManage from '@/page/shop/ShopManage.vue'
import ShopAdd from '@/page/shop/ShopAdd.vue'
import ShopDetail from '@/page/shop/ShopDetail.vue'
import DistributionCenter from '@/page/distribution-center/DistributionCenter.vue'
import DistributionCenterAdd from '@/page/distribution-center/DistributionCenterAdd.vue'
import DistributionCenterDetail from '@/page/distribution-center/DistributionCenterDetail.vue'
import BomManage from '@/page/bom/BomManage.vue'
import BomDetail from '@/page/bom/BomDetail.vue'
import KitchenManage from '@/page/kitchen/KitchenManage.vue'
import KitchenAdd from '@/page/kitchen/KitchenAdd.vue'
import KitchenDetail from '@/page/kitchen/KitchenDetail.vue'
import PurchasePriceManage from '@/page/price/PurchasePriceManage.vue'
import PurchasePriceDetail from '@/page/price/PurchasePriceDetail.vue'
import PurchasePriceHandle from '@/page/price/PurchasePriceHandle.vue'
import ProducePriceManage from '@/page/price/ProducePriceManage.vue'
import ProducePriceDetail from '@/page/price/ProducePriceDetail.vue'
import ProducePriceHandle from '@/page/price/ProducePriceHandle.vue'
import AllotPriceManage from '@/page/price/AllotPriceManage.vue'
import AllotPriceDetail from '@/page/price/AllotPriceDetail.vue'
import AllotPriceHandle from '@/page/price/AllotPriceHandle.vue'
import RequirePriceManage from '@/page/price/RequirePriceManage.vue'
import RequirePriceDetail from '@/page/price/RequirePriceDetail.vue'
import RequirePriceHandle from '@/page/price/RequirePriceHandle.vue'
import SupplierManage from '@/page/supplier/SupplierManage.vue'
import SupplierDetail from '@/page/supplier/SupplierDetail.vue'
import SupplierAdd from '@/page/supplier/SupplierAdd.vue'
import StaffManage from '@/page/staff/StaffManage.vue'
import StaffDetail from '@/page/staff/StaffDetail.vue'
import StaffAdd from '@/page/staff/StaffAdd.vue'
import RoleManage from '@/page/role/RoleManage.vue'
import RoleDetail from '@/page/role/RoleDetail.vue'
import PrintManage from '@/page/print/PrintManage.vue'
import MerchantManage from '@/page/merchant/MerchantManage.vue'
import MerchantDetail from '@/page/merchant/MerchantDetail.vue'
import MerchantAdd from '@/page/merchant/MerchantAdd.vue'
import BrandManage from '@/page/brand/BrandManage.vue'
import BrandDetail from '@/page/brand/BrandDetail.vue'
import LogManage from '@/page/log/LogManage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: '主页'
      },
      children: [
        {
          path: '/',
          name: 'MaterialManage',
          component: MaterialManage,
          meta: {
            title: '货品维护'
          }
        },
        {
          path: '/MaterialAdd',
          name: 'MaterialAdd',
          component: MaterialAdd,
          meta: {
            title: '添加货品'
          }
        },
        {
          path: '/MaterialDetail',
          name: 'MaterialDetail',
          component: MaterialDetail,
          meta: {
            title: '货品详情'
          }
        },
        {
          path: '/unit-manage',
          name: 'unit-manage',
          component: UnitManage,
          meta: {
            title: '单位维护'
          }
        },
        {
          path: '/material-type-manage',
          name: 'material-type-manage',
          component: MaterialTypeManage,
          meta: {
            title: '货品类别维护'
          }
        },
        {
          path: '/ShopManage',
          name: 'ShopManage',
          component: ShopManage,
          meta: {
            title: '门店维护'
          }
        },
        {
          path: '/ShopAdd',
          name: 'ShopAdd',
          component: ShopAdd,
          meta: {
            title: '添加门店'
          }
        },
        {
          path: '/ShopDetail',
          name: 'ShopDetail',
          component: ShopDetail,
          meta: {
            title: '门店详情'
          }
        },
        {
          path: '/DistributionCenter',
          name: 'DistributionCenter',
          component: DistributionCenter,
          meta: {
            title: '配送中心维护'
          }
        },
        {
          path: '/DistributionCenterAdd',
          name: 'DistributionCenterAdd',
          component: DistributionCenterAdd,
          meta: {
            title: '添加配送中心'
          }
        },
        {
          path: '/DistributionCenterDetail',
          name: 'DistributionCenterDetail',
          component: DistributionCenterDetail,
          meta: {
            title: '配送中心详情'
          }
        },
        {
          path: '/BomManage',
          name: 'BomManage',
          component: BomManage,
          meta: {
            title: '配方维护'
          }
        },
        {
          path: '/BomDetail',
          name: 'BomDetail',
          component: BomDetail,
          meta: {
            title: '配方详情'
          }
        },
        {
          path: '/KitchenManage',
          name: 'KitchenManage',
          component: KitchenManage,
          meta: {
            title: '中央厨房维护'
          }
        },
        {
          path: '/KitchenAdd',
          name: 'KitchenAdd',
          component: KitchenAdd,
          meta: {
            title: '添加中央厨房'
          }
        },
        {
          path: '/KitchenDetail',
          name: 'KitchenDetail',
          component: KitchenDetail,
          meta: {
            title: '中央厨房详情'
          }
        },
        {
          path: '/PurchasePriceManage',
          name: 'PurchasePriceManage',
          component: PurchasePriceManage,
          meta: {
            title: '采购调价查询'
          }
        },
        {
          path: '/PurchasePriceDetail',
          name: 'PurchasePriceDetail',
          component: PurchasePriceDetail,
          meta: {
            title: '采购调价详情'
          }
        },
        {
          path: '/PurchasePriceHandle',
          name: 'PurchasePriceHandle',
          component: PurchasePriceHandle,
          meta: {
            title: '采购调价处理'
          }
        },
        {
          path: '/ProducePriceManage',
          name: 'ProducePriceManage',
          component: ProducePriceManage,
          meta: {
            title: '成本调价查询'
          }
        },
        {
          path: '/ProducePriceDetail',
          name: 'ProducePriceDetail',
          component: ProducePriceDetail,
          meta: {
            title: '成本调价详情'
          }
        },
        {
          path: '/ProducePriceHandle',
          name: 'ProducePriceHandle',
          component: ProducePriceHandle,
          meta: {
            title: '成本调价处理'
          }
        },
        {
          path: '/AllotPriceManage',
          name: 'AllotPriceManage',
          component: AllotPriceManage,
          meta: {
            title: '调拨调价查询'
          }
        },
        {
          path: '/AllotPriceDetail',
          name: 'AllotPriceDetail',
          component: AllotPriceDetail,
          meta: {
            title: '调拨调价详情'
          }
        },
        {
          path: '/AllotPriceHandle',
          name: 'AllotPriceHandle',
          component: AllotPriceHandle,
          meta: {
            title: '调拨调价处理'
          }
        },
        {
          path: '/RequirePriceManage',
          name: 'RequirePriceManage',
          component: RequirePriceManage,
          meta: {
            title: '要货调价查询'
          }
        },
        {
          path: '/RequirePriceDetail',
          name: 'RequirePriceDetail',
          component: RequirePriceDetail,
          meta: {
            title: '要货调价详情'
          }
        },
        {
          path: '/RequirePriceHandle',
          name: 'RequirePriceHandle',
          component: RequirePriceHandle,
          meta: {
            title: '要货调价处理'
          }
        },
        {
          path: '/SupplierManage',
          name: 'SupplierManage',
          component: SupplierManage,
          meta: {
            title: '供应商维护'
          }
        },
        {
          path: '/SupplierDetail',
          name: 'SupplierDetail',
          component: SupplierDetail,
          meta: {
            title: '供应商详情'
          }
        },
        {
          path: '/SupplierAdd',
          name: 'SupplierAdd',
          component: SupplierAdd,
          meta: {
            title: '添加独立供应商'
          }
        },
        {
          path: '/StaffManage',
          name: 'StaffManage',
          component: StaffManage,
          meta: {
            title: '员工管理'
          }
        },
        {
          path: '/StaffDetail',
          name: 'StaffDetail',
          component: StaffDetail,
          meta: {
            title: '员工详情'
          }
        },
        {
          path: '/StaffAdd',
          name: 'StaffAdd',
          component: StaffAdd,
          meta: {
            title: '添加员工'
          }
        },
        {
          path: '/RoleManage',
          name: 'RoleManage',
          component: RoleManage,
          meta: {
            title: '角色管理'
          }
        },
        {
          path: '/RoleDetail',
          name: 'RoleDetail',
          component: RoleDetail,
          meta: {
            title: '角色详情'
          }
        },
        {
          path: '/PrintManage',
          name: 'PrintManage',
          component: PrintManage,
          meta: {
            title: '打印尺寸管理'
          }
        },
        {
          path: '/MerchantManage',
          name: 'MerchantManage',
          component: MerchantManage,
          meta: {
            title: '商户管理'
          }
        },
        {
          path: '/MerchantDetail',
          name: 'MerchantDetail',
          component: MerchantDetail,
          meta: {
            title: '商户详情'
          }
        },
        {
          path: '/MerchantAdd',
          name: 'MerchantAdd',
          component: MerchantAdd,
          meta: {
            title: '商户员工'
          }
        },
        {
          path: '/BrandManage',
          name: 'BrandManage',
          component: BrandManage,
          meta: {
            title: '品牌管理'
          }
        },
        {
          path: '/BrandDetail',
          name: 'BrandDetail',
          component: BrandDetail,
          meta: {
            title: '品牌详情'
          }
        },
        {
          path: '/LogManage',
          name: 'LogManage',
          component: LogManage,
          meta: {
            title: '日志管理'
          }
        },
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js